import React, { useEffect, useState } from 'react'
import '../styles/MemberDetails.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import cash from'../assets/images/tc-cash-wallet 1.png';
import units from'../assets/images/tc-units-wallet 2.png';
import wallet2 from '../assets/images/Wallet03.1 1.png';
import wallet1 from '../assets/images/Wallet01 5.png';
import dollarY from '../assets/images/Dollar Bag (1).png';
import dollarG from '../assets/images/Dollar Bag.png';
import history1 from '../assets/images/Group 37483.png';
import oldbank from '../assets/images/bank-pound-icon2 4.png';
import WalletDetails from '../components/WalletDetails';
import { memberService } from '../services/MemberServices';

function MemberWalletPage() {
    const location = useLocation();
    const member = location.state?.member;
    const navigate = useNavigate();

    const goToWallet = () => {
      navigate('/member-wallet-details', {state: {member}})
    }

    const goToRequestHistory = () => {
        navigate('/member-cash-request-history', {state: {member}})
    }

    const goToMemberDetails = () => {
        navigate('/member-details', {state: {member}})
    }

    console.log("Received customer:", member);

    const [walletData, setWalletData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchWallet = async () => {
            try {
                const id = member?.id || member?.member_id;
                if (id) {
                    const data = await memberService.getMemberWallet(id);
                    setWalletData(data);
                }
            } catch (error) {
                console.error("Error fetching wallet details:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchWallet();
    }, [member]);

    // Safely access wallet data with fallbacks
    const totalPoints = walletData?.wallet?.units || member?.value?.replace(' units', '') || "0";
    const cashBalance = walletData?.earned_bonus_reward_wallet?.cash || 0;

  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Member Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-member" className="breadcrumb-link">Manage Member</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Member Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToMemberDetails}>Personal Details</button>
                    <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                    <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
                </div>
            </div>

            {/* Wallet Section */}
            <div className="wallet-section">
                <WalletDetails
                    imgH={wallet2}
                    imgT={dollarG}
                    imgHi={history1}
                    title="TopCoin Wallet (Member)"
                    amount={`${totalPoints} units`}
                    subText="Available TopCoin"
                    bgColor="#f0fdf4"
                    bgColor1="#dcfce7"
                    historyLink="/member-units-transaction-history"
                    stateData={{ member }}
                />

                <WalletDetails
                    imgH={wallet1}
                    imgT={dollarY}
                    imgHi={history1}
                    title="Earned Bonus Reward Wallet (Member)"
                    amount={loading ? "Loading..." : `£ ${cashBalance}`}
                    subText="Available Cash"
                    bgColor="#fff7ed"
                    bgColor1="#ffedd5"
                    showButton={false}
                />

                <WalletDetails
                    imgH={oldbank}
                    imgT={dollarY}
                    title="Withdraw"
                    amount={`£ ${(0).toFixed(2)}`}
                    subText="Available Cash"
                    bgColor="#f5f5f5"
                    bgColor1="#e0e0e0"
                    buttonText="Withdraw"
                    disabled={true}
                    showButton={true}
                />
            </div>
        </div>       
    </div>
  )
}

export default MemberWalletPage